// extracted by mini-css-extract-plugin
export default {"tag":"J0vlZMR","tag--default":"VoZ_Qxz","tag--disabled":"oiuUaV8","tag--lime":"PcYSeBK","tag__button":"dzIT65G","tag__icon":"W8HXNk_"};